export default "__VITE_ASSET__6cd9e42c__"